import Vue from 'vue'
import ICountUp from 'vue-countup-v2';
Vue.component('ICountUp', ICountUp);
